import { Controller } from '@hotwired/stimulus';

/*
  Controller to handle rule rows for custom columns for the Generic Mapper UI
*/
export default class extends Controller {
  static values = { table: String };
  static targets = [
    'grid',
    'rules',
    'template',
    'rule_template',
    'columnNameInput',
    'allButton',
    'mappedButton',
    'unmappedButton',
  ];

  connect() {
    this.mappingMode = 'all';

    this.filterController = this.application.getControllerForElementAndIdentifier(
      this.element,
      'filter'
    );

    if (this.filterController) {
      this.filterController.addFilters(this.mappingStateFilter.bind(this));
    }

    this.updateFilterButtons();
  }

  add() {
    const rawName = this.columnNameInputTarget.value;
    if (!rawName) return;

    const columnName = rawName
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '_')
      .replace(/[^a-z0-9_]/g, '');

    if (!columnName) return;

    if (this.columnExists(columnName)) {
      alert(`Column "${columnName}" already exists`);
      return;
    }
    const fragment = this.templateTarget.content.cloneNode(true);

    fragment.firstElementChild.innerHTML = fragment.firstElementChild.innerHTML.replaceAll(
      '__COLUMN_NAME__',
      columnName
    );

    this.gridTarget.appendChild(fragment);

    // reset input
    this.columnNameInputTarget.value = '';
  }

  add_rule_row() {
    const fragment = this.rule_templateTarget.content.cloneNode(true);
    this.rulesTarget.appendChild(fragment);
  }

  remove(event) {
    const row = event.target.closest('.column-row');
    if (row) row.remove();
  }

  columnExists(name) {
    return this.gridTarget.querySelector(`.column-row[data-column="${name}"]`);
  }

  showAll() {
    this.mappingMode = 'all';
    this.updateFilterButtons();
    if (this.filterController) this.filterController.filter();
  }

  showMapped() {
    this.mappingMode = 'mapped';
    this.updateFilterButtons();
    if (this.filterController) this.filterController.filter();
  }

  showUnmapped() {
    this.mappingMode = 'unmapped';
    this.updateFilterButtons();
    if (this.filterController) this.filterController.filter();
  }

  mappingStateFilter({ el }) {
    if (this.mappingMode === 'all') return true;

    const isMapped = el.dataset.mapped === 'true';

    if (this.mappingMode === 'mapped') return isMapped;
    if (this.mappingMode === 'unmapped') return !isMapped;

    return true;
  }

  updateFilterButtons() {
    const activeClasses = [
      'bg-tealLight',
      'text-white',
      'border-tealMedium',
      'hover:text-gray-700',
    ];
    const inactiveClasses = ['bg-white', 'text-gray-700', 'border-lighterGrayBorder'];

    const setState = (button, active) => {
      if (!button) return;

      button.classList.remove(...activeClasses, ...inactiveClasses);

      if (active) {
        button.classList.add(...activeClasses);
      } else {
        button.classList.add(...inactiveClasses);
      }
    };

    setState(this.hasAllButtonTarget ? this.allButtonTarget : null, this.mappingMode === 'all');
    setState(
      this.hasMappedButtonTarget ? this.mappedButtonTarget : null,
      this.mappingMode === 'mapped'
    );
    setState(
      this.hasUnmappedButtonTarget ? this.unmappedButtonTarget : null,
      this.mappingMode === 'unmapped'
    );
  }
}
